export const styles = theme => ({
    radioGroup: {
        marginTop: "1rem"
    },
    paper: {
        padding: "1rem",
        width: "90%"
    },
    card: {
        height: "490px",
        position: "relative" as const,
        "& h2": {
            fontSize: 18,
            fontWeight: "bold",
        }
    },
    buttonCheckout: {
        position: "absolute" as const,
        width: "100%",
        bottom: 0,
        left: 0,
    },
    explanation: {
        margin: "25px 0",

    }
});
